export const actionTypes = {
  setSnack: "setSnack",
};
const initstate = {
  openSnack: {
    open: false,
    severity: "success",
    msg: "",
  },
};
export const snackReducer = (state = initstate, action) => {
  switch (action.type) {
    case actionTypes.setSnack:
      return { ...state, openSnack: action.payload };
    default:
      return state;
  }
};
export const snackActions = {
  setSnack: (snackInfo) => ({ type: actionTypes.setSnack, payload: snackInfo }),
};
